import { api } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { RouteData } from 'app/containers/Task/slice/types';
import { useSelector } from 'react-redux';

export const useTaskRouteFields = ({
  taskRoutes,
}: {
  taskRoutes: RouteData[];
}) => {
  const envId = useSelector(selectSelectedEnvId) as number;
  const seasonId = useSelector(selectSelectedSeasonId) as number;

  const {
    data: fieldsResponse,
  } = api.endpoints.getFieldsGeometry.useQueryState({
    envId,
    seasonId,
    companyId: null,
    companyGroupId: null,
  });

  const fields = fieldsResponse?.features || [];

  const routeFields = fields
    .map(field => {
      const routeField = {
        field,
        routesOnThisField: taskRoutes
          .filter(
            route =>
              (route.fieldSeasonId || route.nextFieldSeasonId) ===
              field.properties.id,
          )
          .sort((routeA, routeB) => {
            const dateA = new Date(routeA.to).getTime();
            const dateB = new Date(routeB.to).getTime();

            return dateB - dateA;
          }),
      };

      return routeField;
    })
    // Filter out fields without route
    .filter(routeField => routeField.routesOnThisField.length);

  return { routeFields };
};
